import React from 'react';
import moment from 'moment';

import {
    OffsetDateTime
} from "../services/CommonModel"

type DateTimeDescriptionProps = {
    dateTime: OffsetDateTime
}

const DateTimeDescription = ({dateTime} : DateTimeDescriptionProps) => {

    const m = moment(dateTime);
    return (
        <>{m.format("DD/MM/YYYY HH:mm")}</>
    )
};

export default DateTimeDescription;